import api from './api';
import { ApiResponse } from '../types';

export interface ConnectionAgreement {
  id: number;
  connection_id: number;
  professional_function: string;
  hourly_rate: number;
  discount_percent?: number;
  effective_hourly_rate?: number;
  discount_requested?: boolean;
  discount_request_reason?: string | null;
  employer_description?: string | null;
  employer_location?: string | null;
  max_conversations_per_traject: number;
  conversation_report_frequency: 'every_conversation' | 'start_end_only' | 'none' | 'custom';
  custom_report_frequency?: string | null;
  additional_agreements?: string | null;
  created_by: string;
  approved_by_professional: boolean;
  approved_by_employer: boolean;
  approved_at?: string | null;
  created_at: string;
  updated_at: string;
}

export interface RateValidationInfo {
  experienceLevel: string;
  yearsAsZZP: number;
  minRate: number;
  maxRate: number;
}

export interface CreateAgreementRequest {
  professional_function: string;
  // Required for professionals; for employers this is computed automatically.
  hourly_rate?: number;
  discount_percent?: number;
  discount_requested?: boolean;
  discount_request_reason?: string;
  employer_description?: string;
  employer_location?: string;
  max_conversations_per_traject: number;
  conversation_report_frequency: 'every_conversation' | 'start_end_only' | 'none' | 'custom';
  custom_report_frequency?: string;
  additional_agreements?: string;
}

export const connectionAgreementsAPI = {
  // Get agreement for a connection
  getAgreement: async (connectionId: number): Promise<ConnectionAgreement | null> => {
    const response = await api.get<ApiResponse<ConnectionAgreement | null>>(
      `/professional/connections/${connectionId}/agreements`
    );
    return response.data.data ?? null;
  },

  // Create agreement
  createAgreement: async (
    connectionId: number,
    data: CreateAgreementRequest
  ): Promise<ConnectionAgreement> => {
    const response = await api.post<ApiResponse<ConnectionAgreement>>(
      `/professional/connections/${connectionId}/agreements`,
      data
    );
    return response.data.data!;
  },

  // Update agreement
  updateAgreement: async (
    connectionId: number,
    data: Partial<CreateAgreementRequest>
  ): Promise<ConnectionAgreement> => {
    const response = await api.patch<ApiResponse<ConnectionAgreement>>(
      `/professional/connections/${connectionId}/agreements`,
      data
    );
    return response.data.data!;
  },

  // Approve agreement
  approveAgreement: async (connectionId: number): Promise<ConnectionAgreement> => {
    const response = await api.post<ApiResponse<ConnectionAgreement>>(
      `/professional/connections/${connectionId}/agreements/approve`
    );
    return response.data.data!;
  }
};

